var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0033 143.997H26V178.909C26 182.381 27.3792 185.711 29.8342 188.166C32.2891 190.621 35.6188 192 39.0906 192H74.0033V143.997Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0033 0H39.0906C35.6188 0 32.2891 1.37919 29.8342 3.83415C27.3792 6.28912 26 9.61877 26 13.0906L26 143.997H74.0033V48.0033H117.634V0H74.0033Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.638 143.997H117.634V192H152.547C156.019 192 159.348 190.621 161.803 188.166C164.258 185.711 165.638 182.381 165.638 178.909V143.997Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.634 143.997H74.0034V192H117.634V143.997Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.634 48.0034V143.997H165.638V48.0034H117.634Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.634 0V48.0033H165.638L117.634 0Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.638,
    height: 192,
    fill: "white",
    transform: "translate(26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/Drive.5efdf534004a0e62c7791788997c85f0.svg";
export { ForwardRef as ReactComponent };